import {memo} from "react";
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    vendorName: string;
    headerText: string;
    vendorLogo: string | null;
}

export const ApplicationVendorInfo = memo((props: IProps) => {
    return (
        <div className={headerStyle}>
            {props.vendorLogo && (
                <Image className={imageHolderStyle} width="78px" height="58px" alt={`Logo dewelopera: ${props.vendorName}`} src={props.vendorLogo} />
            )}
            <div className={textHolderStyle}>
                <Text variant="body_copy_0" className={askAboutOfferStyle} color="var(--colors-secondary)">
                    {props.headerText}
                </Text>
                <Text variant="info_txt_1" className={vendorNameStyle}>
                    {props.vendorName}
                </Text>
            </div>
        </div>
    );
});

const headerStyle = css({
    marginBottom: 2,
    display: "flex",
    alignItems: "center"
});

const textHolderStyle = css({
    marginLeft: 2,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column"
});

const imageHolderStyle = css({
    minWidth: "min-content",
    maxWidth: "78px"
});

const vendorNameStyle = css({
    color: "var(--colors-gray-700)"
});

const askAboutOfferStyle = css({
    margin: "0 0 0.2rem 0"
});
import {memo} from "react";
import {css} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    vendorName: string;
    headerText: string;
    vendorLogo: string | null;
}

export const ApplicationVendorInfo = memo((props: IProps) => {
    return (
        <div className={headerStyle}>
            {props.vendorLogo && (
                <Image className={imageHolderStyle} width="78px" height="58px" alt={`Logo dewelopera: ${props.vendorName}`} src={props.vendorLogo} />
            )}
            <div className={textHolderStyle}>
                <Text variant="body_copy_0" className={askAboutOfferStyle} color="var(--colors-secondary)">
                    {props.headerText}
                </Text>
                <Text variant="info_txt_1" className={vendorNameStyle}>
                    {props.vendorName}
                </Text>
            </div>
        </div>
    );
});

const headerStyle = css({
    marginBottom: 2,
    display: "flex",
    alignItems: "center"
});

const textHolderStyle = css({
    marginLeft: 2,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column"
});

const imageHolderStyle = css({
    minWidth: "min-content",
    maxWidth: "78px"
});

const vendorNameStyle = css({
    color: "var(--colors-gray-700)"
});

const askAboutOfferStyle = css({
    margin: "0 0 0.2rem 0"
});
